import React, { useEffect, useState } from 'react';
import { Row, Col, Carousel, Table } from 'react-bootstrap';
import { get } from '../../services/apiController';
import { ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';

const CakeOrderPrint = () => {
  const { orderId } = useParams();

  const [data, setData] = useState({});

  const [productImageIndex, setProductImageIndex] = useState(0);
  const [uploadedImageIndex, setUploadedImageIndex] = useState(0);

  useEffect(() => {
    get(`/cake/orders/${orderId}`)
      .then((res) => setData(res.data))
      .catch((err) => console.log('err', err));
  }, [orderId]);

  const BasePath = data.syncedOnBucket ? process.env.REACT_APP_DIGITAL_OCEAN_URL : process.env.REACT_APP_BASE_URL;

  return (
    <React.Fragment>
      <ToastContainer />
      <div style={{ padding: '25px' }}>
        <Row>
          <Col xs={6}>
            <div className="px-2">
              <h6>Product Images</h6>
              <Carousel
                className="text-center bg-dark px-2 mb-4"
                activeIndex={productImageIndex}
                onSelect={(selectedIndex) => setProductImageIndex(selectedIndex)}
              >
                {Array.isArray(data?.product?.images) ? (
                  data?.product?.images?.map((img, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <img src={`${process.env.REACT_APP_BASE_URL}/${img}`} width="400px" height="400px" alt={data?.product?.name} />
                      </Carousel.Item>
                    );
                  })
                ) : data?.product?.images ? (
                  <Carousel.Item>
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}/${data?.product?.images}`}
                      width="400px"
                      height="400px"
                      alt={data?.product?.name}
                    />
                  </Carousel.Item>
                ) : (
                  ''
                )}
              </Carousel>
            </div>
          </Col>
          <Col xs={6}>
            <div className="px-2">
              <h6>Uploaded Images</h6>
              <Carousel
                className="text-center bg-dark px-2 mb-4"
                activeIndex={uploadedImageIndex}
                onSelect={(selectedIndex) => setUploadedImageIndex(selectedIndex)}
              >
                {Array.isArray(data?.images) ? (
                  data?.images?.map((img, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <img src={`${BasePath}/${img}`} width="400px" height="400px" alt={data?.name} />
                      </Carousel.Item>
                    );
                  })
                ) : data?.images ? (
                  <Carousel.Item>
                    <img src={`${BasePath}/${data?.images}`} width="400px" height="400px" alt={data?.name} />
                  </Carousel.Item>
                ) : (
                  ''
                )}
              </Carousel>
            </div>
          </Col>
        </Row>
        <Table bordered striped className="mb-3">
          <thead>
            <tr>
              <th>Shop Location</th>
              <th>Order Number</th>
              <th>Flavour</th>
              <th>Weight</th>
              <th>Name on the cake</th>
              <th>Cake Name</th>
              <th>Product Code</th>
              <th>Delivery Date</th>
              <th>Extra Charge</th>
              <th>Shape</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{`${data?.location?.name} (${data?.location?.number})`}</td>
              <td>{data?.orderNumber}</td>
              <td>{data?.flavour?.name}</td>
              <td>{data?.weight}</td>
              <td>{data?.nameOnCake}</td>
              <td>{data?.product?.name}</td>
              <td>{data?.product?.productCode}</td>
              <td>{moment(data?.deliveryDate).format('DD/MM/YYYY')}</td>
              <td>{data?.extraCharge}</td>
              <td>{data?.shape?.name}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </React.Fragment>
  );
};

export default CakeOrderPrint;
